// src/config/quillSetup.ts

import Quill from 'quill';
export const DEFAULT_SIZES = ['12px', '14px', '16px', '18px', '20px', '24px', '32px'];

/**
 * Register custom font sizes with Quill
 * This must be called before any Quill editor is initialized
 * NOTE:
 * Quill.import() returns `unknown` due to incomplete typings from Quill.
 * Runtime behavior is correct and safe.
 */
export const registerQuillCustomSizes = (): void => {
  const SizeStyle = Quill.import('attributors/style/size');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  SizeStyle.whitelist = DEFAULT_SIZES;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  Quill.register(SizeStyle, true);
};

/**
 * Default font list for Quill editor
 */
export const DEFAULT_FONTS = ['arial', 'times-new-roman', 'ms-p-gothic',]; 

/**
 * Register custom fonts with Quill (optional)
 * This must be called before any Quill editor is initialized
 * NOTE:
 * Quill.import() returns `unknown` due to incomplete typings from Quill.
 * Runtime behavior is correct and safe.
 */
export const registerQuillCustomFonts = (): void => {
  const FontStyle = Quill.import('attributors/style/font');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  FontStyle.whitelist = DEFAULT_FONTS;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  Quill.register(FontStyle, true);
};

/**
 * Initialize all Quill custom configurations
 * Call this once in your app initialization
 */
export const initializeQuillConfig = (): void => {
  registerQuillCustomSizes();
  registerQuillCustomFonts();
};
